import React, { useContext, useEffect, useMemo, useState } from "react";
import Swal from "sweetalert2";
import SelectControl from "../SelecControl/SelectControl.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBackspace } from "@fortawesome/free-solid-svg-icons";
import proveedorContext from "../../context/proveedoresContext/proveedorContext.js";
import { createEstructuraProveedor } from "../../utils/estructuras.js";

import './ServTercerosSubtabla.css';
import { useScrollToBottom } from "../../customHooks/useScrollToBottom.js";

const ServTercerosSubtabla = ({req = {}, setState, proveedores = [], tablaSeleccionada, handleChangeProveedores, handleDeleteProveedores, tipo, componentePadre, hasWebServiceConfigured}) =>{

    const {proveedoresList, getProveedorFromInforme} = useContext(proveedorContext);
    const containerRef = useScrollToBottom(proveedores.length);

    const proveedoresOptions = useMemo(()=>{
        return proveedoresList.map(p => ({id: p._id, value: p.nroCta, label: p.nombre}));
    },[proveedoresList])
    
    const handleGetServicios = async () => {
        if(hasWebServiceConfigured){
                let proveedoresNotFound = [];
                let res = await getProveedorFromInforme(req);
                    try {
                        if(res.obtenidos){
                            Swal.fire('Aguarde un momento...');
                            setState({...req, proveedores: [{...createEstructuraProveedor()}]});
                            let proveedoresToSet = [];
                            let i = 0;
                            res.proveedores.forEach((p, indexToSet) => {
                                let proveedorFound = proveedoresList.find(prov => p.nroCta == prov.nroCta);
                                if(proveedorFound == undefined || proveedorFound == null){
                                    proveedoresNotFound.push(p);
                                }else{
                                    proveedoresToSet.push({proveedor:{id:proveedorFound._id, value: p.nroCta, label: proveedorFound.nombre}, importe: p.importe, textAdic: p.textoAdic});
                                }
                            })
                            if(proveedoresNotFound.length == 0){
                                handleChangeProveedores({}, 0, '', '', proveedoresToSet);
                                Swal.fire({
                                    title: 'Éxito',
                                    icon: 'success',
                                    text: res.msg
                                })        
                            } 
                            else {
                                Swal.fire({
                                    title: 'No se puede ejecutar la recuperación!',
                                    icon: 'error',
                                    html: `Los proveedores ${proveedoresNotFound.map(p => `<strong>${p.nroCta}</strong>`).join(' , ')} no existen en la base de XertuX.`
                                })
                                console.log("proveedoresNotFound");
                                console.log(proveedoresNotFound);
                            }
                        }else{
                            Swal.fire({
                                title: 'No se puede ejecutar la recuperación!',
                                icon: 'error',
                                text: res.msg
                            })
                        }
                    } catch (error) {
                        console.log("Error en handleGetProductsFromConsumo");
                        console.log(error);
                        Swal.fire({
                            title: 'Error',
                            icon: 'error',
                            text: error.message
                        })
                    }
                }else{
                    Swal.fire({
                        title:"No es posible actualizar desde Consumos Reales!", 
                        html:"No se ha configurado una conexión con un sistema externo. <br> Si desea configurar un sistema externo comuníquese con el soporte de XertuX",
                        confirmButtonColor:'#3d4d87',
                    });
                }
    }

    return <div className={`${tablaSeleccionada != 'servTerceros' && 'inactive'} imputacionesRRHHDiv`}>
        <div className="subtablaHeaderLabel">
            <label>Proveedores por {componentePadre == 'Activo' ? 'Activo' : componentePadre == 'FormReq' ? 'Orden de Trabajo' : 'Procedimiento'}</label> 
            {componentePadre == 'FormReq' && <button className="btn" onClick={handleGetServicios}>Actualizar desde Entregas Reales</button>}
        </div>
        <div className={`headerSubtabla`}>
            <label></label>
            <label>Proveedor</label>
            <label>Importe</label>
            <label>Texto Adicional</label>
        </div>
        <div className="bodyTable" ref={containerRef}>
            {(proveedores != undefined && proveedores.length > 0) && proveedores.map((p, index) => <div className="rrCategoriasAsociadas" key={index}>
                <FontAwesomeIcon icon={faBackspace} color="red" style={{ width: '80px', height: '40px', marginTop: "5px", cursor: "pointer" }} onClick={()=>handleDeleteProveedores(p,index)} />
                <SelectControl placeholder={"Seleccione un proveedor..."} modo={"Nuevo"} handleChengeSelect={handleChangeProveedores} optionsSelect={proveedoresOptions} valueSeleccionada={p.proveedor} tipo={'proveedor'} propToChange="proveedor" selectSelect={handleChangeProveedores} index={index}/>
                <input value={p.importe} onChange={(e) => handleChangeProveedores({},index,'importe',e.target.value)} type="number"/>
                <input value={p.textAdic} onChange={(e) => handleChangeProveedores({},index,'textAdic',e.target.value)}/>
            </div>)}
        </div>
    </div>
}

export default ServTercerosSubtabla;